
export type LectureDetailResourcesItemType = typeof LectureDetailResourcesItemType[keyof typeof LectureDetailResourcesItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LectureDetailResourcesItemType = {
  PDF: 'PDF',
  LINK: 'LINK',
  CODE: 'CODE',
  DOWNLOAD: 'DOWNLOAD',
} as const;
